import React from "react";
import "../sass/layout/_experiences.scss";
import "../sass/base/_typogrophy.scss";
import experiences_2 from "../static/images/experiences_2.jpg";
import LazyImage from "../components/LazyImage.js";
const NewComponent = () => {

  return (
    <div className="image-container">
      <LazyImage imgOnly={true} src={experiences_2} alt="" className="experience-img" />
    </div>
  )
}

export const Experiences = () => {
  return <NewComponent />
  // return <LazyImage component={<Carousel data={EXPERIENCES} addMargin={true} imgs={IMAGES} />} />;
};
